import React from 'react';
import { useDispatch } from 'react-redux';
import { Rate, Badge, Progress, Tooltip, Button, Tag } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { addToCart } from '../store/reducers/cartSlice';
import { ShoppingCartOutlined, FireOutlined } from '@ant-design/icons';

const MeilleursVentes = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleAddToCart = () => {
    dispatch(addToCart({
      id: props.id,
      product_title: props.product_title,
      price: props.price,
      quantity: 1,
      image1: props.image1,
    }));
  };

  return (
    <div className='col-12 col-sm-6 col-lg-4 mb-4'>
      <div className='special-product-card p-3 shadow-sm rounded'>
        <div className='d-flex flex-column gap-3'>

          {/* Image & Badge */}
          <div className='position-relative text-center'>
            <img
              src={props.image1}
              alt={props.product_title}
              className='img-fluid rounded bestseller_image'
              style={{ maxHeight: '180px', objectFit: 'cover', cursor: 'pointer' }}
              onClick={() => navigate(`/product/${props.id}`)}
            />
            <Badge.Ribbon text="🔥 Offre" color="volcano" />
            <div className='mt-2'>
              <Link className='farmers-link text-primary fw-bold'>{props.farmers_number} producteurs</Link>
            </div>
          </div>

          {/* Infos produit */}
          <div className='text-start'>
            <h5 className='text-muted'>{props.product_category}</h5>
            <h6 className='fw-bold'>{props.product_title}</h6>
            <Rate disabled value={props.star_number} />
            <p className='price mt-1'>
              <span className='text-danger fw-bold'>{props.price} </span>{' '}
              <strike className='text-muted'>{props.actual_price} FCFA</strike>
            </p>

            {/* Barre de progression */}
            <div className='prod-count my-2'>
              <p className='mb-1'>Disponible : {props.in_stock}</p>
              <Progress percent={props.progress_bar || 25} size="small" status="active" />
            </div>

            {/* Countdown fictif */}
            <div className='discount-till d-flex align-items-center gap-2'>
              <Tooltip title="Jours restants">
                <Tag color="red">{props.days} jours</Tag>
              </Tooltip>
              <Tag color="processing">00:00:00</Tag>
            </div>

            {/* Actions */}
            <div className='d-flex justify-content-between mt-3'>
              <Button
                type='link'
                className='button text-white'
                onClick={() => navigate(`/product/${props.id}`)}
              >
                Voir plus
              </Button>
              <Button
                className='application-button'
                icon={<ShoppingCartOutlined />}
                onClick={handleAddToCart}
              >
                Ajouter
              </Button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default MeilleursVentes;
